import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {InspectableItemType, InspectorEvent} from '../types';

@Injectable({
    providedIn: 'root',
})
export class InspectorService {

    // Inspector General
    // Currently inspected item type
    private inspectorItemSubject: BehaviorSubject<InspectableItemType | null> = new BehaviorSubject<InspectableItemType | null>(null);
    public getInspectorItem$(): Observable<InspectableItemType | null>{
        return this.inspectorItemSubject.asObservable();
    }
    public getCurrentInspectorItem(): InspectableItemType | null {
        return this.inspectorItemSubject.getValue();
    }
    public changeItem(inspectorItem: InspectableItemType | null){
        this.inspectorItemSubject.next(inspectorItem);
    }

    private inspectorEventSubject: Subject<InspectorEvent> = new Subject<InspectorEvent>();
    public getInspectorEvent$(): Observable<InspectorEvent>{
        return this.inspectorEventSubject.asObservable();
    }
    public raiseInspectorEvent(event: InspectorEvent){
        this.inspectorEventSubject.next(event);
    }

    // Audit Inspector
    // Switch to Finding Tab
    private switchToFindingTabSubject: Subject<void> = new Subject<void>();
    public switchToFindingTabSubject$(): Observable<void>{
        return this.switchToFindingTabSubject.asObservable();
    }

    /*
    public switchToFindingTab(){
        this.switchToFindingTabSubject.next();
    }

    // Screenshot Inspector
    // Screenshot gets opened inside the inspector
    private screenshotSubject: Subject<string> = new Subject();

    public getScreenshotSubject$(): Observable<string>{
        return this.screenshotSubject.asObservable();
    }

    public changeScreenshot(url: string){
        this.screenshotSubject.next(url);
    }
    */
}
